module.exports = __webpack_public_path__ + "img/login-bg-mob.83f3eea3.jpg";